import React from 'react';

import { H1 } from '@betterment/samba-react';

export const SectionTitle: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <H1 variant="title200" css={{ mt: 'space.300', mb: 'space.100' }}>
    {children}
  </H1>
);
